const SET_UPLOADS = "SET_UPLOADS";

// Define reducer function
const planReducer = (state = { remainingUploads: 0 }, action) => {
  switch (action.type) {
    case SET_UPLOADS:
      return {
        ...state,
        remainingUploads: action.payload.remainingUploads,
      };
    default:
      return state;
  }
};

const set_uploads = (remainingUploads) => ({
  type: SET_UPLOADS,
  payload: { remainingUploads },
});

export { set_uploads };
export default planReducer;
